var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.339665 15.0382C3.41987 14.7977 6.1548 12.6544 6.99998 9.50012C7.84517 6.34584 6.54829 3.12224 4.00104 1.3738C4.82788 1.30922 5.67959 1.38175 6.52631 1.60863C10.5273 2.68069 12.9017 6.79322 11.8296 10.7942C10.7575 14.7952 6.64502 17.1696 2.64402 16.0975C1.79731 15.8706 1.02344 15.5076 0.339665 15.0382Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.339665 15.0382L0.261799 14.0413L-2.55887 14.2616L-0.226251 15.8627L0.339665 15.0382ZM4.00104 1.3738L3.92318 0.376837L1.10251 0.597141L3.43513 2.19826L4.00104 1.3738ZM6.03406 9.2413C5.30197 11.9735 2.93273 13.8327 0.261799 14.0413L0.417531 16.0352C3.907 15.7627 7.00763 13.3353 7.96591 9.75894L6.03406 9.2413ZM3.43513 2.19826C5.64392 3.71439 6.76615 6.5091 6.03406 9.2413L7.96591 9.75894C8.92419 6.18258 7.45266 2.5301 4.56696 0.549338L3.43513 2.19826ZM4.07891 2.37076C4.79414 2.3149 5.53194 2.37746 6.26749 2.57455L6.78513 0.6427C5.82724 0.386035 4.86161 0.303542 3.92318 0.376837L4.07891 2.37076ZM6.26749 2.57455C9.73502 3.50367 11.7928 7.06786 10.8637 10.5354L12.7955 11.053C14.0105 6.51857 11.3196 1.85771 6.78513 0.6427L6.26749 2.57455ZM10.8637 10.5354C9.93456 14.0029 6.37037 16.0607 2.90284 15.1316L2.38521 17.0634C6.91967 18.2784 11.5805 15.5875 12.7955 11.053L10.8637 10.5354ZM2.90284 15.1316C2.16729 14.9345 1.49706 14.6198 0.905581 14.2138L-0.226251 15.8627C0.549812 16.3954 1.42732 16.8068 2.38521 17.0634L2.90284 15.1316Z",
    fill: "#6c6a91",
    mask: "url(#path-1-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMoon);
export default __webpack_public_path__ + "static/media/lightMoon.d9f84d000403f8ec9775f4398c33381a.svg";
export { ForwardRef as ReactComponent };